// Mutations
export const SET_AUTH = 'auth.set';

